import { ProgressBar } from "react-aria-components";
import { cx } from "@/lib/cx";

/**
 * Determinate bar (value / max) in the accent, or an indeterminate shimmer when the total is not
 * known yet. `label` is the accessible name; `valueText` is the visible, localized caption.
 */
export function Progress({
  label,
  value,
  max = 100,
  valueText,
  className,
}: {
  label: string;
  value?: number;
  max?: number;
  valueText?: string;
  className?: string;
}) {
  const indeterminate = value === undefined;
  return (
    <ProgressBar
      aria-label={label}
      value={value}
      maxValue={max}
      isIndeterminate={indeterminate}
      valueLabel={valueText}
      className={cx("flex flex-col gap-1.5", className)}
    >
      {({ percentage }) => (
        <>
          <div className="h-1.5 overflow-hidden rounded-full bg-hover">
            <div
              className={cx(
                "h-full rounded-full bg-accent transition-[width] duration-(--dur-slow) ease-out",
                indeterminate && "w-1/3",
              )}
              style={
                indeterminate
                  ? {
                      backgroundImage: "linear-gradient(90deg, var(--accent), var(--accent-text), var(--accent))",
                      backgroundSize: "200% 100%",
                      animation: "pt-shimmer 1.4s ease-in-out infinite",
                    }
                  : { width: `${percentage}%` }
              }
            />
          </div>
          {valueText ? <span className="text-xs text-fg-muted tnum">{valueText}</span> : null}
        </>
      )}
    </ProgressBar>
  );
}
